<template>
  <div class="feedback-page">
    <p class="page__hd">{{all?'用户说':'内部反馈'}}</p>
    <div class="page__bd">
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext" class="feedback-list">
        <div class="weui-panel feedback-item" v-for="(item,xindex) in items" :key="item.id">
          <div class="weui-panel__bd">
            <div class="weui-media-box weui-media-box_text">
              <p class="feedback-item__title">
                {{item.creatorName}}
                <span v-if="all">@{{item.companyName}}</span>
              </p>
              <p>{{item.fb_msg}}</p>
              <ul class="weui-media-box__info">
                <li
                  class="weui-media-box__info__meta"
                  v-format="'yyyy年MM月dd日 hh:mm'"
                >{{item.createTime}}</li>
                <li
                  v-if="!all"
                  class="weui-media-box__info__meta info-right"
                  @click="showOperation(xindex)"
                >
                  <span class="iconfont icon-more"></span>
                </li>
              </ul>
              <div class="feedback-item__reply" v-if="item.fb_reply">
                <span class="feedback-item__reply-title">{{item.updaterName}}</span>
                :&nbsp;{{item.fb_reply}}
              </div>
            </div>
          </div>
        </div>
      </scroll-list>
    </div>
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  props: {
    all: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/commons/feedBack/list"
    };
  },
  computed: {
    extraParams() {
      return { all: this.all };
    }
  },
  methods: {
    showOperation(index) {
      var me = this;
      me.$weui.actionSheet([
        {
          label: "删除",
          onClick: function() {
            me.removeItem(index);
          }
        }
      ]);
    },
    removeItem(index) {
      var me = this,
        id = me.items[index].id;
      me.$loading({
        url: "/api/commons/feedBack/delete/" + id,
        method: "POST"
      })
        .then(function(res) {
          if (res.success) {
            me.$weui.toast("删除成功", 2000);
            me.items.splice(index, 1);
          } else {
            me.$weui.topTips("删除失败: " + res.message, 3000);
          }
        })
        .catch(function() {
          me.$weui.topTips("删除失败", 3000);
        });
    }
  }
};
</script>

<style>
.feedback-page {
  display: flex;
  flex-direction: column;
}
.feedback-page .page__hd {
  padding: 16px 16px 13px;
  color: var(--weui-FG-0);
  font-size: 15px;
  font-weight: 700;
}
.feedback-page .page__bd {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.feedback-item__title {
  font-size: 14px;
  color: var(--weui-LINK);
  margin-bottom: 10px;
}
.feedback-item__reply {
  background-color: #f8f8f8;
  padding: 10px;
  margin-top: 16px;
}
.feedback-item .weui-media-box__info__meta {
  font-size: 12px;
}
.feedback-item__reply-title {
  color: var(--weui-ORANGE);
}
.weui-media-box__info__meta.info-right {
  float: right;
}
.feedback-list .weui-cells {
  background-color: transparent;
}
.feedback-list .weui-cells:after {
  display: none;
}
</style>